import { html, TemplateResult } from "lit-html";
import { ifDefined } from "lit-html/directives/if-defined"

const ButtonComponent = ({
  id,
  type,
  cssClasses,
  disable,
  btnText = '',
  eventHandlers
}: IButtonElement): TemplateResult => {
  return html`
    <button
    id=${ifDefined(id)}
    type=${type}
    class=${ifDefined(cssClasses)}
    ?disabled=${disable}
    @click=${eventHandlers?.onClick}
    >
    ${btnText}
    </button>
    `;
}

export default ButtonComponent;